/**
 * -----------------------------------------------------------------------------
 * Renders the excel icon.
 */
export function ExcelIcon() {
  return (
    <svg
      fill="none"
      height="60"
      viewBox="0 0 60 60"
      width="60"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="fill-green-800 "
        clipRule="evenodd"
        d="M32.6418 12.3613V47.2783L11.8821 43.6794V15.9602L32.6418 12.3613ZM33.6282 16.3922H47.4147C48.1767 16.3922 48.3229 16.5418 48.3229 17.3004V42.3358C48.3229 43.0944 48.1767 43.244 47.4147 43.244H33.6282V40.8834H38.8904V37.2573H33.6282V36.1688H38.8904V32.5393H33.6282V31.4508H38.8904V27.8214H33.6282V26.7329H38.8904V23.1068H33.6282V22.0183H38.8904V18.3889H33.6282V16.3922ZM7.0859 53.0405H52.9184L52.9252 7.20117H7.0791L7.0859 53.0405Z"
        fillRule="evenodd"
      />
      <path
        className="fill-green-800 "
        clipRule="evenodd"
        d="M24.2493 23.3379L22.358 27.6647L20.8885 23.5999L18.5245 23.7053L20.8715 29.6274L18.2285 35.4203L20.5518 35.5937L22.4158 31.4268L24.1506 35.8352L26.8242 35.9815L23.9261 29.6036L26.6984 23.1611L24.2493 23.3379ZM39.978 40.8831H45.9648V37.2571H39.978V40.8831ZM39.978 36.1686H45.9648V32.5391H39.978V36.1686ZM39.978 31.4506H45.9648V27.8212H39.978V31.4506ZM39.978 22.0181H45.9648V18.3887H39.978V22.0181ZM39.978 26.7327H45.9648V23.1066H39.978V26.7327Z"
        fillRule="evenodd"
      />
    </svg>
  );
}
